<template>
	<div class="scrollable only-y">
	<div class="page-header card-base card-shadow--medium" v-loading="loadingDetail" element-loading-background="rgba(0, 0, 0, 0.8)">
		<h2 class="no-m white-text"><i class="mdi mdi-account widget-icon accent-text fs-30"></i> {{ consumen.customer_name }}</h2>
	</div>
	<!-- <el-alert class="mb-5" type="info" title="Information" description="Billing tab under maintenance" show-icon="" :closable="false"></el-alert> -->
	<el-card>
		<div slot="header">
			<span>Consumen Detail</span>
			<!-- <el-button style="float: right;" size="mini" type="default" @click="$router.push('/consumen')">Back</el-button> -->
		</div>

      	<el-tabs v-model="activeTab" type="border-card" @tab-click="tabClick">
	        <!-- TAB Customer Detail -->
				<el-tab-pane label="Detail" name="detail">
					<detail :init-consumen="consumen" :init-loading="loadingDetail" />
				</el-tab-pane>

	        <!-- TAB Product -->
				<el-tab-pane label="Product" name="product">
					<product
						:loading-page="loadingConsumenProduct"
						:product="product"
						:customer-name="consumen.customer_name"
						:waUserDetail="waUserDetail"
						:list-product="listProduct"
						:list-product-user="product" />
				</el-tab-pane>

	        <!-- TAB Service -->
				<el-tab-pane label="Service" name="service">
					<service
						:loading-init="loadingService"
						:list-services="listServices"
						:list-webhooks="webhooks"/>
				</el-tab-pane>

				<el-tab-pane label="Additional Service" name="additional_service">
					<additionalService :prop-loading="loadingAdditionalService"
						:prop-product="listProduct" 
						:prop-services="additionalService" 
						:prop-additionalproduct="productAdditional"/>
				</el-tab-pane>

			<!-- TAB Report Notification -->
				<el-tab-pane label="Report" name="report_notification">
					<report
						:date-range="dateRange"
						:loading-report="loadingReport"
						:messages="messages"
						:total="totalMessages"
						:bm-status="fbbmStatus"
						:status-message="statusMessages"
						:status-usage="statusUsages"
						:sender="sender"
						:filter="filter"/>
				</el-tab-pane>

			<!-- TAB Report Usage -->
				<!-- <el-tab-pane label="Monitoring" name="quota_ussage">
						<quota-ussage
						:loading-invoice="loadingInvoice"
						:selectedMonth="selectedMonth"
						:tableData="tableData"
						:total-billing="totalBill"
						:number="whatsappNumber" />
				</el-tab-pane> -->
			
			<!-- TAB Credit Quota -->
				<el-tab-pane label="Credit Quota" name="credit_quota">
						<credit-quota
						:loading-invoice="loadingInvoice"
						:selectedMonth="selectedMonth"
						:number="whatsappNumber" />
				</el-tab-pane>

	        <!-- TAB Billing -->
				<el-tab-pane label="New Billing" name="billing">
						<billing
						:loading-invoice="loadingInvoice"
						:selectedMonth="selectedMonth"
						:billing="whatsappBilling"
						:total-billing="totalBill"
						:customer-name="consumen.customer_name"
						:number="whatsappNumber" />
				</el-tab-pane>
			  
			<!-- TAB Assigned Template Message -->
				<el-tab-pane label="Assigned Template" name="asigned_template">
					<template-hsm
						:waUserDetail="waUserDetail"
						:datahsm="Datahsm"
						:detail="userDetailOne"
						:customer-name="consumen.customer_name"
						:loading-temp="loadingTemplate"
						:loading-list-hsm-temp="loadingListHsm" />
				</el-tab-pane>

			<!-- TAB Configuration -->
				<el-tab-pane label="Configuration" name="configuration">
					<configuration
					:waUserDetail="waUserDetail"
					:datahsm="Datahsm"
					:data-user="userDetailAll"
					:loadingPage="loadingConfiguration"
					:services="listServices"
					:configuration="configuration"/>
	        	</el-tab-pane>

			<!-- TAB Inquiry Number -->
				<!-- <el-tab-pane label="Check contact" name="inquiry">
					<inquiry-number
					:number="waUserDetail.sender"/>
	       		</el-tab-pane> -->

			<!-- TAB Member -->
				<el-tab-pane label="Member" name="member">
					<member
					:waUserDetail="waUserDetail"
					:datahsm="Datahsm"
					:detail="userDetailOne"
					:customer-name="consumen.customer_name"
					:loading-temp="loadingTemplate"
					:loading-list-hsm-temp="loadingListHsm" 
					:list="listMember"
					:loading-page="loadingMember"
					:loading-page-division="loadingTabDivision" />
	        	</el-tab-pane>

			  	<!-- <el-tab-pane label="Log Monit" name="logger">
					<logger
					:loading-page="loadingLogger" />
	       	</el-tab-pane> -->
      	</el-tabs>
    </el-card>
	<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
		DAM Corp.
	</el-card>
	</div>
</template>

<script>
// import io from 'socket.io-client';
// const socket = io('http://localhost:7789');
// const socket = io('http://202.158.139.93:7789', {transports: ['websocket'], upgrade: false});
// console.log(socket)
import Detail from './consumen/Detail.vue'
import Service from './consumen/PanelService.vue'
import Product from './consumen/Product.vue'
import Overview from './consumen/Overview.vue'
import Report from './consumen/Report.vue'
import QuotaUssage from './consumen/QuotaUsage.vue'
import CreditQuota from './consumen/CreditQuota.vue'
import Billing from './consumen/Billing.vue'
// import QuotaUsage from './consumen/QuotaUsage.vue'
import TemplateHsm from './consumen/Template.vue'
import Configuration from './consumen/Configuration.vue'
import Member from './consumen/Member.vue'
import InquiryNumber from './consumen/InquiryNumber'
import AdditionalService from './consumen/AdditionalService'
// import Logger from './consumen/Log'

import api from '@/networkClient'
import config from '@/config'
import Ussage from './consumen/Ussage.vue'
const moment = require('moment')

export default {
   name: 'Consumen_Detail',
	components: {
		Detail,
		Product,
		Service,
		Overview,
		Report,
		QuotaUssage,
		CreditQuota,
		Billing,
		// QuotaUsage,
		TemplateHsm,
		Configuration,
		Member,
		InquiryNumber,
		AdditionalService,
		Ussage,
		// Logger
	},
	data () {
		return {
			tableData:[],
			hsm:{
				success: [0],
				fail: [0],
				total: [0]
			},
			outbond: {
				success: [0],
				fail: [0],
				total: [0]
			},
			tanggal: [],
			// tabPosition: 'top',
			consumen: {},
			configuration:[],
			// allConsumen: [],
			product: [],
			listProduct: [],
			loadingDetail: true,
			loadingConsumen:true,
			loadingConsumenProduct: false,
			loadingOverview: false,
			loadingReport: true,
			loadingInvoice: false,
			loadingTemplate: false,
			// loadingBilling:false,
			// loadingLogger: false,
			// loadingApprove: false,
			loadingListHsm: false,
			loadingService: false,
			loadingAdditionalService: false,
			additionalService: [],
			productAdditional: [],
			listServices: {
				service: []
			},
			// formLabelWidth: '200px',
			// loadingBtn: false,
			// currentPage: 1,
			// total:0,
			totalMessages: [],
            activeTab: 'detail',
            // activeNames: '1',
            // dialogConfirm: false,
			// dialogTableVisible: false,
			// dialogFormVisible: false,
			// dialogChangePrice: false,
			// dialogShowCust: false,
			// dialogAddServiceUser: false,
            // billing:[],
            // loadingTable: true,
            // showFormMessage: true,
            // totalBill: 0,
            // billWhatsapp: {},
            /* waServAlias: {
				text: "Whatsapp Regular Text",
				hsm: "Whatsapp Template Text",
				image: "Whatsapp Image",
				document: "Whatsapp Document",
				audio: "Whatsapp Audio"
			}, */
			currentMonth: moment().format('YYYY-MM'),
			selectedMonth:  moment().format("M"),
            // today: moment().format('DD MMM YYYY'),
            // clientName: '',
            // companyName: '',
            // companyPhone: '',
            whatsappBilling: [],
            whatsappNumber: [],
            // isLoading:true,
            // loadingData: true,
            // clientName: '',
            // companyName: '',
            // companyPhone: '',
			// totalWA: 0,
			showFormMessage: false,
			showAlertMessage: false,
			showAlertError: false,
			dateRange: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD")
            ],
            // today: moment().format('DD MMM YYYY'),
			// billWhatsapp: {},
			/* waServAlias: {
				text: "Whatsapp Regular Text",
				hsm: "Whatsapp Template Text",
				image: "Whatsapp Image",
				document: "Whatsapp Document",
				audio: "Whatsapp Audio"
			}, */
			totalBill: 0,
			// loadingTable: true,
			// options: [],
			// value: "1",
			// optionsYear: [],
			year: "2019",
			waUserDetail : {
				hsm : [],
				sender : [],
				detail: []
			},
			sender : [],
			filter: "created_at",
			// startDate: new Date(),
			// endDate: new Date(),
			/* excelFields: {
				"Date": "dateTimeIso",
				"Time": "dateTimeIso",
				"From": "from",
				"To": "to",
				"Delivered": "delivered"
			}, */
			// selectedPhoneNumber: '',
			// selectedHsm: '',
			// selectProductAssigned:'',
			messages:[],
			// loadingPage: true,
			// resData:[],
			Datahsm:[],
			/* form:{
				token_whatsapp:'',
				phone_wa:''
			}, */
			statusMessages: {
				read:0,
                sent:0,
                failed:0,
                delivered:0,
                invalid: 0,
			},
			statusUsages: {
                cbp: {
                    total: 0,
                    ui: 0,
                    bi: 0
                },
                bi: 0,
                ui: 0,
                int_bi: 0,
                int_ui: 0
            },
			fbbmStatus: {},
			loadingConfiguration: false,
			userDetailOne: {},
			userDetailAll: {},
			listMember: {},
			division :[{
				data :[]
			}],
			totalDivision: 0,
			loadingMember: false,
			loadingTabDivision: false,
			webhooks: [],
			dataReport: {}
		}
	},
	methods: {
		/* async paginateReport(page){
			this.currentPage = page
			await this.getReport(this.currentPage)
		},
        capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatDate(val, format){
            return moment(val).local().format(format)
		},
		monthName(val){
			let month = _.find(this.options, 'value')
			return month.label
		}, */
		async detailConsumen(){
            this.loadingDetail = true
            let custId = this.$route.params.consumen
            await api({
                url: config.baseApi + 'consumen/' + custId,
                method: 'get'
            })
            .then(res => {
                this.consumen = res.data.data.consumen
				// console.log(this.consumen)
                this.consumen.created_at = moment(this.consumen.created_at).format("YYYY-MM-DD HH:mm:ss")
            })
            .catch(err => {

            })
            this.loadingDetail = false
        },
		/* async getBusinessId(){
            this.loadingDetail = true
            let custId = this.$route.params.consumen
            await api({
                url: config.baseApi + 'consumen/businessId/' + custId,
                method: 'get'
            })
            .then(res => {
                if(res.data.ec == 200){
                    // console.log(res.data.data.bussinessId)
                    this.businessId = res.data.data.bussinessId
                } else {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                }
            })
            .catch(err => {

            })
            this.loadingDetail = false
        }, */
        async detailConsumenProduct(){
            this.loadingConsumenProduct = true
            let custId = this.$route.params.consumen
            await api({
                url: config.baseApi + 'consumen/' + custId + "/product",
                method: 'get'
            })
            .then(res => {
				this.product = res.data.data.filter(e => e.product)
            })
            .catch(err => {

            })
            this.loadingConsumenProduct = false
        },
        /* print() {
			window.print()
		}, */
        async getBilling(){
            this.loadingInvoice = true
            let custId = this.$route.params.consumen
            await api({
                url: config.baseApi + 'consumen/' + custId + "/get_new_billing",
                method: 'post',
                data:{
                    months: this.currentMonth,
					with_date: false,
					billing: true
				},
				timeout: (10 * 60) * 1000
            })
            .then(res => {
                let tempNumber = new Array()
				let tempBilling = new Array()
				let i = 0
				this.totalBill = 0
                if(res.data.ec == 200){
                    // _.forEach(res.data.data, dt => {
					// 	tempNumber.push(dt.phone_number)
					// 	tempBilling[i] = new Array()
					// 	let tempTax = new Array()
					// 	let j = 0
					// 	_.forEach(dt.billing, billing => {
					// 		let dtpush = {
					// 			product: billing.product,
					// 			delivered: billing.delivered,
					// 			total: billing.billing,
					// 			detail: billing.detail ? billing.detail.filter(v => v.count > 0) : billing.detail
					// 		}

					// 		if(billing.serviceFee){
					// 			this.totalBill += parseFloat(billing.serviceFee)
					// 			tempTax.push({ product: { productName: "Service Fee", type: "" }, delivered: "", total: parseFloat(billing.serviceFee) })
					// 		}
					// 		// if(billing.serviceFeeTax){
					// 		// 	this.totalBill += parseFloat(billing.serviceFeeTax)
					// 		// 	tempTax.push({ product: { productName: "Service Fee Tax", type: "" }, delivered: "", total: parseFloat(billing.serviceFeeTax) })
					// 		// }
					// 		if(billing.billingTax){
					// 			this.totalBill += parseFloat(billing.billingTax)
					// 			tempTax.push({ product: { productName: billing.product.productName + " Tax", type: "" }, delivered: "", total: parseFloat(billing.billingTax )})
					// 		}

					// 		tempBilling[i].push(dtpush)
					// 		if(j+1 == dt.billing.length){
					// 			_.forEach(tempTax, tax => {
					// 				tempBilling[i].push(tax)
					// 			})
					// 		}
					// 		if(Array.isArray(billing.detail)) {
					// 			billing.detail.forEach(detail => {
					// 				this.totalBill += detail.total
					// 			})
					// 		} else {
					// 			this.totalBill += billing.billing
					// 		}
					// 		j++
					// 	})
					// 	i++;
					// })
					this.whatsappNumber = tempNumber
                    this.whatsappBilling =
						res &&
						res.data &&
						!res.data.data
							? res.data.data
							: [];

					if (this.whatsappBilling.length > 0) {
						this.whatsappBilling = this.whatsappBilling.map((el,n) => {
							el.list = String.fromCharCode(97 + n).toUpperCase()
							// el.productType = el.productType ? el.productType.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : '-'

							if (el.productName && el.productName.toLowerCase() == 'whatsapp conversation') {
								el.cbp_usage = el.cbp_usage || 0
								el.bi_usage = el.bi_usage || 0
								el.ui_usage = el.ui_usage || 0
								el.international_usage = el.international_usage || 0

								switch (el.productType) {
									case 'notification':
										el.productType = 'CBP Invoice'
										break;
									case 'notification_caping':
										el.productType = 'CBP Caping'

										break;
									case 'notification_caping_plafon':
										el.productType = 'CBP Hybrid'

										if (el.prepaid == 'true') {
                                                el.productType += ' - Bundle'
                                            }
                                            else{
                                                el.productType += ' - Plafon'
                                            }
										break;
								}

								
							}
							else {
								el.productType = el.productType ? el.productType.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : '-'
							}

							return el
						})
					}
                }
                this.loadingInvoice = false
            })
            .catch(err => {
				this.loadingInvoice = false
            })
        },
		async getQuota(){
            this.loadingInvoice = true
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/monthly_usage",
                method: 'post',
                data:{
                    months: this.currentMonth,
                    with_date: false
                },
                timeout: (10 * 60) * 1000
            }
            await api(
                apiOptions
            )
            .then(res => {
                let tempNumber = new Array()
                let tempBilling = new Array()
                let i = 0
                let date = ""
                if(res.data.ec == 200 || query == "download"){

                        if (res.data.data.detail) {
                            let datas = res.data.data.detail.count_limit || []

                            if (datas.length > 0) {
                                datas = datas.map(el => {
									if (el) {
										if (el.productName && el.productName.toLowerCase() == 'whatsapp conversation') {
											el.cbp_usage = el.cbp_usage || 0
											el.bi_usage = el.bi_usage || 0
											el.ui_usage = el.ui_usage || 0
											el.international_usage = el.international_usage || 0
	
											switch (el.productType) {
												case 'notification':
													el.productType = 'CBP Invoice'
													break;
												case 'notification_caping':
													el.productType = 'CBP Caping'
													break;
												case 'notification_caping_plafon':
													el.productType = 'CBP Hybrid'
													break;
											}
										}
										
										let findTraffic = res.data.data.detail.traffic.find(val => el.customerNumber == val.phone_number) || null
    
                                        el.traffic = findTraffic.traffic
									}

                                    return el
                                })

								datas = datas.filter(v => v != null)
                            }

                            this.tableData = datas
                        }
                } else {
                    // this.$swal('info', `Monthly usage not subscribe`, "error").then(this.clear())
                }
                this.loadingInvoice = false
            })
            .catch(err => {
                console.log(err)
				this.loadingInvoice = false
            })
        },
        async getOverview(){
            this.loadingOverview =  true
            let custId = this.$route.params.consumen
			await api({
				method: 'post',
				url: config.baseApi + 'consumen/' + custId + "/overview",
				data: {
					months: [this.currentMonth],
					with_date: true
				}
			}).then(result => {
				if(result.data.ec == 200){
					this.showFormMessage = true
					let datas = result.data.data[0]

					let tempTanggal = new Array()
					let tempText = {success: new Array(), fail: new Array(), total: new Array()}
					let tempImage = {success: new Array(), fail: new Array(), total: new Array()}
					let tempHSM = {success: new Array(), fail: new Array(), total: new Array()}
					let tempDoc = {success: new Array(), fail: new Array(), total: new Array()}
					let tempAudio = {success: new Array(), fail: new Array(), total: new Array()}
					let tempOutbond = {success: new Array(), fail: new Array(), total: new Array()}
					let priceWhatsapp = new Array()

					_.forOwn(datas.dates, (value, key) => {
						let tgl = moment(`2018-${datas.month}-${value.date}`).format("YYYY-MM-DD")
						tempTanggal.push(tgl)
						// Text
						let dt = value.delivered.text + value.read.text
						let ft = value.fail.text
						tempText.success.push(dt)
						tempText.total.push(dt+ft)
						tempText.fail.push(ft)

						// Image
						let di = value.delivered.image + value.read.image
						let fi = value.fail.image
						tempImage.success.push(di)
						tempImage.fail.push(fi)
						tempImage.total.push(di+fi)

						// HSM
						let dh = value.delivered.hsm + value.read.hsm
						let fh = value.fail.hsm
						tempHSM.success.push(dh)
						tempHSM.fail.push(fh)
						tempHSM.total.push(dh+fh)

						// Document
						let dd = value.delivered.document + value.read.document
						let fd = value.fail.document
						tempDoc.success.push(dd)
						tempDoc.fail.push(fd)
						tempDoc.total.push(dd+fd)

						// Audio
						let da = value.delivered.audio + value.read.audio
						let fa = value.fail.audio
						tempAudio.success.push(da)
						tempAudio.fail.push(fa)
						tempAudio.total.push(da+fa)

						let dout = dt + di + dd + da
						let fout = ft + fi + fd + fa
						tempOutbond.success.push(dout)
						tempOutbond.fail.push(fout)
						tempOutbond.total.push(dout + fout)
					})
					this.tanggal = tempTanggal
					this.textSuccess = tempText.success
					this.textFail = tempText.fail
					this.textTotal = tempText.total

					this.image = tempImage
					this.hsm = tempHSM
					this.document = tempDoc
					this.audio = tempAudio
					this.outbond = tempOutbond
				} else if(result.data.ec == 400 && result.data.message == "not_subscribe"){
					this.showAlertMessage = true
				} else if(result.data.ec == 500){
					this.showAlertError = true
				}

			}).catch(error => {
				this.showAlertError = true
			})
            this.loadingOverview = false
		},
		async getReport(page=1){
			this.loadingReport = true
			let custId = this.$route.params.consumen
			let apiOptions = {
                url: config.baseApi+ "user/"+custId+"/report/notification?page="+page,
                method: 'post',
                data:{
					"year":this.year.toString(),
					"startDate":this.dateRange[0],
                    "endDate":this.dateRange[1],
					"number":this.waUserDetail.sender[0],
					// "filter_by": this.filter
				},
				timeout: (10 * 60) * 1000
			}
            await api(apiOptions)
            .then(res => {
				if(res.data.ec == 200){
					// this.resData = res.data.data
					// this.messages = _.orderBy(this.messages, function(o) { return new moment(o.dateTimeIso); }, ['desc'])
					// this.month = res.data.data.month
					this.sender = this.waUserDetail.sender.slice()
					this.dateRange = this.dateRange.slice()
					this.totalMessages = [res.data.data.total]
					this.messages = res.data.data.messages
					this.statusMessages = res.data.data.status
					this.fbbmStatus = res.data.data.fbbm ? res.data.data.fbbm : {
						sent: 0,
						delivered: 0
					}

					let usage =  res.data.data.usage || null

					if (usage) {
						this.statusUsages.cbp.total = (usage.national.cbp.bi || 0) + (usage.national.cbp.ui || 0)
						this.statusUsages.cbp.bi = usage.national.cbp.bi || 0
						this.statusUsages.cbp.ui = usage.national.cbp.ui || 0
						this.statusUsages.bi = (usage.national.bi || 0)
						this.statusUsages.ui = (usage.national.ui || 0)
						this.statusUsages.int_bi = (usage.international.bi || 0)
						this.statusUsages.int_ui = (usage.international.ui || 0)
					}
				}
            })
            .catch(err => {
				this.showAlertError = true
            })
            this.loadingReport = false
		},
		async loadWA() {
			let custId = this.$route.params.consumen
			await api({
				method: 'post',
				url: config.baseApi +'user/'+custId+'/detail_number'
			}).then(result => {
				// console.log(result.data)
				if(result.data.ec == 200){
					this.waUserDetail.sender = _.uniq(result.data.data)
					// console.log(this.waUserDetail.sender)
				} else {
					this.showAlertError = true
				}
			}).catch(error => {
				this.showAlertError = true
			})
		},
        /* async updatedPrice(){
			this.loadingBtn = true
            let productID = this.$route.params.products
			await api({
				url: '',
				method: 'patch',
				data: {
					"price": this.product.price
				}
			}).then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
					this.dialogChangePrice
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success")
					this.dialogChangePrice
					this.detailConsumenProduct()
				}
			}).catch(err => {
            })
            this.loadingBtn=false
		}, */
		async getAllHSM(){
			this.loadingListHsm = true
			var self = this
			await api({
				url:config.baseApi+'get_hsm',
				method:'GET'
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.Datahsm = response.data.data
				}
			}).catch(error => {
				
			})
			this.loadingListHsm = false
		},
		/* async loadConsumen(){
			this.loadingConsumen = true
			var self = this
			await api({
				url:config.baseApi+'consumen',
				method:'GET'
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.allConsumen = response.data.data.consumen
					this.total = response.data.data.total
				}
			}).catch(error => {
			})
			this.loadingConsumen = false
		}, */
		async loadMember(page = 1){
            this.loadingMember = true
            await api({
                method: 'get',
                url: 'consumen/' + this.$route.params.consumen + "/member"
            }).then(result => {
                if(result.data.ec == 200){
                    this.listMember = result.data.data
                } else{
					this.listMember = []
                }
            }).catch(err => {

            })
            this.loadingMember = false
		},
		async getDivision(page = 1){
            this.loadingTabDivision = true
            var custId = this.$route.params.consumen
            await api({
                methods: 'get',
                url: config.baseApi+'division/list/'+custId+'?page='+page
            }).then(response => {
                this.division.data = response.data.data
                this.totalDivision = parseInt(response.data.total)
                this.loadingTabDivision = false
            }).catch(error => {
                console.log(error)
            })
        },
		async loadProduct(){
			this.loadingConsumen = true
			this.listProduct = []
            await api({
				url: config.baseApi + "product",
				params: {
					per_page: 100
				},
                method: 'get'
            })
            .then(res => {
				var products = res.data.data.product
				// console.log(products)
				products.forEach(element => {
					this.listProduct.push({
						_id: element._id,
						productName:element.productName,
						type: element.type,
						aliasName:element.aliasName,
						productSKU:element.productSKU,
						allowedPrefix: element.allowedPrefix.length > 0 ? element.allowedPrefix : null
					})
				});
            })
            .catch(err => {

            })
            this.loadingConsumen = false
		},
		async loadWaSingle(){
            this.loadingTemplate = true
			let custId = this.$route.params.consumen
			await api({
				method: 'post',
				url: config.baseApi +'user/'+custId+'/detail_one',
				data: {
					number: this.waUserDetail.sender[0]
				}
			}).then(result => {
                // console.log(this.hsmUser)
				if(result.data.ec == 200){
                    this.userDetailOne = result.data.data
					this.userDetailOne.hsm = _.remove(result.data.data.hsm, (v) => { return _.isEmpty(v) == false })
				} else if(result.data.ec == 400 && result.data.message == "not_subscribe"){
					// this.showAlertMessage = true
				}
			}).catch(error => {
				console.log('Error :', error);
            })
            this.loadingTemplate = false
		},
		/* async loadWaAll() {
			let custId = this.$route.params.consumen
			this.loadingConfiguration = true
			await api({
				method: 'post',
				url: config.baseApi +'user/'+custId+'/detail'
			}).then(result => {
				// console.log(result.data)
				this.userDetailAll = { detail: [], hsm: [], sender: [] }
				if(result.data.ec == 200){
					let tempHsm = []
                    let tempSender = []
                    _.forEach(result.data.data, res => {
                        _.forEach(res.hsm, hsm => {
                            tempHsm.push(hsm)
                        })
                        tempSender.push(res.phoneNumber)
                        this.userDetailAll.detail.push(res)
                    })
                    this.userDetailAll.hsm = _.uniqBy(tempHsm, 'name')
                    this.userDetailAll.sender = _.uniq(tempSender)
				}
			}).catch(error => {
				
			})
			this.loadingConfiguration = false
		}, */
		async loadNumberToken() {
			let custId = this.$route.params.consumen
			this.loadingConfiguration = true
			await api({
				method: 'post',
				url: config.baseApi +'user/'+custId+'/detail_number_token'
			}).then(result => {
				// console.log(result.data)
				this.userDetailAll = { detail: [], hsm: [], sender: [] }
				if(result.data.ec == 200){
					let tempHsm = []
                    let tempSender = []
                    _.forEach(result.data.data, res => {
                        _.forEach(res.hsm, hsm => {
                            tempHsm.push(hsm)
                        })
                        tempSender.push(res.phoneNumber)
                        this.userDetailAll.detail.push(res)
                    })
                    this.userDetailAll.hsm = _.uniqBy(tempHsm, 'name')
                    this.userDetailAll.sender = _.uniq(tempSender)
				}
			}).catch(error => {
				
			})
			this.loadingConfiguration = false
		},
		async loadService(){
			let custId = this.$route.params.consumen
			this.loadingService = true
			await api({
				method: "get",
				url: config.baseApi + "consumen/" + custId + "/services"
			}).then(resp => {
				if(resp.data.ec == 200) this.listServices = resp.data.data
			}).catch(err => {
				console.log("failed", err)
			})
			this.loadingService = false
		},
		async loadWebhooks() {
			this.loadingService = true
            const pWebhooks = []
			let data =
				this.listServices &&
				this.listServices.services
					? this.listServices.services
					: [];

            data.forEach(async (e, i) => {
                if (e.service[0].name === 'line') {
                    pWebhooks[i] = api({
                        url: e.service[0].inquiryUrl + 'webhook',
                        headers: { Authorization: `Bearer ${e.service[0].fields.token}` }
                    });
                }
            })
            this.webhooks = await Promise.all(pWebhooks)
                .then(res => res.map(e => e ? e.data.data.webhooks : e))
			this.loadingService = false
        },
		async getAdditionalService(){
            let custId = this.$route.params.consumen
            await api({
                url: config.baseApi + 'consumen/' + custId + "/additional-services",
                method: 'get'
            })
            .then(res => {
				if(res.data.ec == 200){
					this.additionalService = res.data.data.services
					// this.additionalProduct = res.data.data.services
					var prodAddt = res.data.data.services
					prodAddt.forEach(element => {
						// this.additionalProduct = element.product
						// console.log('product additionaal',element)
						this.productAdditional.push({
							productName:element.productName,
							aliasName:element.aliasName,
							productSKU:element.productSKU
						})
					});
					// console.log('additional service',this.additionalService)
					// console.log('additional product',this.additionalProduct)
				}
            })
            .catch(err => {
                return err
            })
        },
        async tabClick(targetName){
            if(targetName.name=='detail'){
				await this.detailConsumen()
            } else if (targetName.name=='product'){
				this.loadWA()
				await this.detailConsumenProduct()
				await this.loadProduct()
            } else if (targetName.name=='billing') {
				// this.loadWA()
				await this.getBilling()
			} else if (targetName.name=='quota_ussage') {
				this.loadWA()
				await this.getQuota()
			} else if (targetName.name=='overview'){
				this.loadWA()
                await this.getOverview()
            } else if (targetName.name=='asigned_template'){
				// this.loadWA()
				await this.loadWaSingle()
				await this.getAllHSM()
			} else if (targetName.name=="report_notification"){
				//this.loadWA()
				await this.detailConsumenProduct()
				await this.getReport()
			} else if (targetName.name=="configuration"){
				this.loadWA()
				await this.loadService()
				await this.loadNumberToken()
			} else if (targetName.name=="member"){
				await this.loadMember()
				await this.getDivision()
			} else if(targetName.name == "service"){
				await this.loadService()
				this.loadWebhooks()
			} else if(targetName.name == "additional_service"){
				this.loadingAdditionalService = true
				await this.getAdditionalService()
				this.loadingAdditionalService = false
			}
		}
	},
	created() {
		this.detailConsumen()
		this.loadWA()
	},
	async mounted() {
		await this.getReport();
	}
	/* async beforeMount(){
		this.loadingTable = false
    },
	async mounted(){
		let year = []
		let i = 0
		let yearNow = new Date().getFullYear()
		let yearStart = new Date().getFullYear() - 2
		for(i = yearNow; i >= yearStart; i--){
			year.push({ value: i, label: i })
		}
		this.optionsYear = year
		this.monthName(1)
		// console.log(this.selectedPhoneNumber)
	},
	async beforeMount(){
		for(let i = 6; i >= 0; i--){
			// console.log("a", moment().subtract(i, 'month').format("MM YYYY"))
			this.options.push({
				value: moment().subtract(i, 'month').format("YYYY-MM"),
				label: moment().subtract(i, 'month').format("MMM YYYY")
			}) 
		}
	} */
}
</script>
<style>
.swal2-container {
	z-index: 10000 !important;
}
</style>
<style lang="scss">
@import '../assets/scss/_variables';
.chart {
     width: 100%;
     height: 400px;
 }
.page-invoice {
	.toolbar {
		max-width: 794px;
		margin: 0 auto;
		text-align: right;
		margin-bottom: 20px;
	}

	.invoice {
		background: white;
		width: 100%;
		max-width: 794px;
		min-height: 1123px;
		margin: 0 auto;
		padding: 2em;
		box-sizing: border-box;
		box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

		hr {
			border: 1px solid rgba(0, 0, 0, 0.05);
		}

		.invoice-top {
			overflow: hidden;
			margin-bottom: 30px;

			.logo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: rgba(0, 0, 0, 0.07);
				text-align: center;

				img {
					height: 80%;
					margin-top: 10%;
				}
			}
			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}
			.title {
				float: right;

				& > * {
					margin: 0;
				}

				p {
					text-align: right;
				}
			}
		}

		.invoice-middle {
			overflow: hidden;
			margin-top: 30px;
			margin-bottom: 30px;

			.clientlogo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: grey;

				img {
					width: 100%;
				}
			}

			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}

			.project {
				margin-left: 52%;

				& > * {
					margin: 0;
				}
			}
		}

		.invoice-bottom {
			table {
				width: 100%;
				border-collapse: collapse;

				th {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					opacity: .7;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				td {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					border-bottom: 1px solid #EEE;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				tfoot td {
					border: none;
					padding-top: 5px;
				}
			}
		}

		h1 { font-size: 1.5em; color: #222; }
		h2 { font-size: .9em; }
		h3 { font-size: 1.2em; font-weight: 300; line-height: 2em; }
		p  { font-size: .7em; color: #666; line-height: 1.2em; }
	}

}


@media screen and (max-width: 768px) {
	.page-invoice {
		.invoice {
			.invoice-middle {
				.project {
					display: block;
					width: 100%;
					clear: both;
					padding: 10px 0;
					margin: 0;
				}
			}
			.invoice-bottom {
				table {
					th {
						padding: 5px;
					}

					td {
						padding: 5px;
					}
				}
			}
		}
	}
}

@media print{
	.layout-container .container .footer ,
	.layout-container .container .header ,
	.layout-container .container .horizontal-nav ,
	.layout-container .footer ,
	.layout-container .layout-picker ,
	.layout-container .vertical-nav ,
	.layout-container .header {
		display:none;
	}

	.page-invoice {
		.toolbar {
			display: none;
		}

		.invoice {
			box-shadow: none;
			max-width: 100%;
			padding: 0;
		}
	}
}
</style>
